import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import "./Member.css";
import Navbar from "./Navbar";
import Membertable from "./Membertable";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./header";
import ApiConfig from "../../common/config/ApiConfig";
import showValidateErrors from "../../common/utils/showValidateErrors";
import MemberCommissionTables, {
  emptyThaiCommission,
  emptySixFieldCommission,
} from "./PageComponents/Member/CommissionTables";
import { useLanguage } from "../../common/i18n/LanguageContext";

function Member() {
  const { t } = useLanguage();
  const [open, setOpen] = React.useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [bank, setBank] = useState("");
  const [banknumber, setBanknumber] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [currencyId, setCurrencyId] = useState(1);
  const [permission, setPermission] = useState();

  const [thCommission, setThCommission] = useState(emptyThaiCommission());
  const [hanoiCommission, setHanoiCommission] = useState(
    emptySixFieldCommission(),
  );
  const [laosCommission, setLaosCommission] = useState(
    emptySixFieldCommission(),
  );
  const [yeekee5Commission, setYeekee5Commission] = useState(
    emptySixFieldCommission(),
  );
  const [yeekee10Commission, setYeekee10Commission] = useState(
    emptySixFieldCommission(),
  );
  const [yeekee15Commission, setYeekee15Commission] = useState(
    emptySixFieldCommission(),
  );

  const [suffix1, setSuffix1] = useState(0);
  const [suffix2, setSuffix2] = useState(0);
  const [suffix3, setSuffix3] = useState(0);
  const [vpassword, setvPassword] = useState(false);
  const [vfname, setvFname] = useState(false);
  const [vlname, setvLname] = useState(false);
  const [vmobileNumber, setvMobileNumber] = useState(false);
  const [vbank, setvBank] = useState(false);
  const [vbanknumber, setvBanknumber] = useState(false);

  const user = localStorage.getItem("user");
  const id = localStorage.getItem("subuserid");
  const pos = localStorage.getItem("position");

  // Membertable (rendered below) reads the same `username` URL param to
  // scope its member list when drilling into a specific agent's downline —
  // this page's own add-member dialog follows the same agent, not always
  // the logged-in user. (Membertable has its own, separately-scoped
  // upline-commission fetch for its edit dialog — the two can't share one
  // fetch since each dialog's own package selection scopes it differently.)
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const byAgent = searchParams.get("username");

  // The suggested username prefix must come from whichever agent will
  // actually own this member — when a senior/master drills down to add a
  // member under a specific downline agent (byAgent), the prefix has to
  // reflect that agent's own username, not the logged-in senior/master's;
  // only a direct self-login add (no drill-down) falls back to `user`.
  const prefixSource = byAgent ?? user;
  const prefix = prefixSource ? prefixSource.slice(-4) : "";

  const getpermission = () => {
    ApiConfig.get(`/getpermissionid?id=${encodeURIComponent(id)}`).then(
      (data) => {
        if (data.resCode !== 200) {
          toast.error(data.message || t("common_load_error"), {
            position: "top-right",
            autoClose: 3000,
          });
          return;
        }
        setPermission(data.data[0]);
      },
    );
  };

  // A member picks its own package per lotto_type (unlike an agent, which
  // enables several at once via `packages`) — packageIds is keyed by the
  // raw lotto_type string, one entry per type. The upline-commission cap
  // per type is fetched inside MemberCommissionTables itself now (it needs
  // to react to whichever type's tab/package is currently active).
  const [packages, setPackages] = useState([]);
  const [packageIds, setPackageIds] = useState({});
  const getPackages = () => {
    ApiConfig.get(
      `/getAgentPackageList?username=${encodeURIComponent(byAgent ?? user)}`,
    ).then((result) => {
      if (result.resCode !== 200) return;
      setPackages(Array.isArray(result.data) ? result.data : []);
    });
  };

  // Only an owner adding a member directly (no drill-down) picks a
  // currency; under a downline agent (byAgent) the backend fixes it to that
  // agent's currency, and for anyone else to their own.
  const canPickCurrency = pos === "owner" && !byAgent;
  useEffect(() => {
    if (!canPickCurrency) return;
    ApiConfig.get("/getCurrencyList").then((result) => {
      if (result.resCode !== 200) return;
      const list = Array.isArray(result.data) ? result.data : [];
      setCurrencies(list);
      if (list.length > 0 && !list.some((c) => c.id === 1)) {
        setCurrencyId(list[0].id);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getPackages();
    setPackageIds({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [byAgent]);

  const handleClose = () => {
    setOpen(false);
    setUsername(prefix);
    setPassword("");
    setFname("");
    setLname("");
    setMobileNumber("");
    setBank("");
    setBanknumber("");
    setPackageIds({});
    setThCommission(emptyThaiCommission());
    setHanoiCommission(emptySixFieldCommission());
    setLaosCommission(emptySixFieldCommission());
    setYeekee5Commission(emptySixFieldCommission());
    setYeekee10Commission(emptySixFieldCommission());
    setYeekee15Commission(emptySixFieldCommission());

    setSuffix1(0);
    setSuffix2(0);
    setSuffix3(0);
    setvPassword(false);
    setvFname(false);
    setvLname(false);
    setvMobileNumber(false);
    setvBank(false);
    setvBanknumber(false);
  };

  const handleClickOpen = () => {
    if (pos === "sub_account") {
      getpermission();
      if (permission.add_member === 1) {
        setOpen(true);
      } else {
        alert(t("common_no_permission"));
      }
    } else {
      setUsername(prefix);
      setOpen(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Submitting form with values:", {
      username,
      suffix1,
      suffix2,
      suffix3,
      password,
      fname,
      lname,
      mobileNumber,
      bank,
      banknumber,
      user,
    });
    if (
      !username ||
      !password ||
      !fname ||
      !lname ||
      !mobileNumber ||
      !bank ||
      !banknumber ||
      !user
    ) {
      toast.error(t("member_fill_all_fields"), {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      if (!password) {
        setvPassword(true);
      } else setvPassword(false);

      if (!fname) {
        setvFname(true);
      } else setvFname(false);

      if (!lname) {
        setvLname(true);
      } else setvLname(false);

      if (!mobileNumber) {
        setvMobileNumber(true);
      } else setvMobileNumber(false);

      if (!bank) {
        setvBank(true);
      } else setvBank(false);

      if (!banknumber) {
        setvBanknumber(true);
      } else setvBanknumber(false);
      return;
    }

    // At least one lotto_type needs a package — a member with none selected
    // at all would be created with every type disabled/zeroed, which is
    // never actually useful. Individual types are still allowed to stay
    // unset (that lotto_type just isn't offered to this member).
    if (!Object.values(packageIds).some(Boolean)) {
      toast.error(t("member_package_required"), {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const json = {
      Username: username,
      Password: password,
      acctIdSuffix1: String(suffix1),
      acctIdSuffix2: String(suffix2),
      acctIdSuffix3: String(suffix3),
      fname: fname,
      lname: lname,
      phone: mobileNumber,
      bank: bank,
      accout: banknumber,
      // Adding a member from a drill-down page (e.g. .../member?...&agent=X)
      // must assign it under that downline agent X, not whoever is logged
      // in — same `byAgent` used for package fetching / commission table
      // above, kept consistent with those.
      agent: byAgent ?? user,
      ...(canPickCurrency ? { currency_id: currencyId } : {}),
      th_package_id: packageIds.th_gov,
      hanoi_package_id: packageIds.hanoy_PhuQua,
      laos_package_id: packageIds.laos_gov,
      yeekee5_package_id: packageIds.Yeekee_5,
      yeekee10_package_id: packageIds.Yeekee_10,
      yeekee15_package_id: packageIds.Yeekee_15,
      th_commission: thCommission,
      hanoi_commission: hanoiCommission,
      laos_commission: laosCommission,
      yeekee5_commission: yeekee5Commission,
      yeekee10_commission: yeekee10Commission,
      yeekee15_commission: yeekee15Commission,
    };

    ApiConfig.post("/register", json)
      .then((result) => {
        if (result.resCode === 422) {
          if (Array.isArray(result.errors) && result.errors.length > 0) {
            showValidateErrors(result.errors);
          } else {
            toast.error(result.message || t("member_register_error"), {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          return;
        }
        if (result.resCode === 200) {
          setUsername("");
          setPassword("");
          setFname("");
          setLname("");
          setMobileNumber("");
          setBank("");
          setBanknumber("");
          setPackageIds({});
          setThCommission(emptyThaiCommission());
          setHanoiCommission(emptySixFieldCommission());
          setLaosCommission(emptySixFieldCommission());
          setYeekee5Commission(emptySixFieldCommission());
          setYeekee10Commission(emptySixFieldCommission());
          setYeekee15Commission(emptySixFieldCommission());
          toast.success(t("member_add_success"), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setOpen(false);
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        } else {
          toast.error(result.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(() => {
        toast.error(t("member_register_error"), {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title={t("member_page_title")} />
          </div>
          <div className="flex-1 overflow-y-auto">
            <div
              className="p-1 mb-1 h-[2em] w-auto inline-flex items-center rounded border-solid bg-gradient-to-b from-brand-gold-300 via-brand-gold-400 to-brand-gold-600 text-brand-ink-onGold border-brand-gold-200 shadow-gold hover:brightness-105 cursor-pointer"
              onClick={handleClickOpen}
            >
              <GroupAddIcon sx={{ fontSize: 16 }} className="ml-1" />
              <span className="ml-1 text-xs font-bold">
                {t("member_add_button")}
              </span>
            </div>
            <Membertable packages={packages} />
            {open && (
              <div>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  PaperProps={{
                    style: { width: "1100px", maxWidth: "95vw" },
                  }}
                >
                  <div className="App">
                    <form onSubmit={handleSubmit}>
                      <DialogTitle
                        className="text-white bg-brand-blue-800"
                        id="alert-dialog-title"
                        sx={{ fontSize: "1rem", py: 1 }}
                      >
                        {t("member_add_dialog_title")}
                      </DialogTitle>
                      <DialogContent>
                        <div className="grid grid-cols-2 p-2 mt-2 border-[1px] bg-amber-100 border-slate-400 rounded-lg gap-4">
                          <div>
                            <label
                              htmlFor="username"
                              className="block mb-1 font-bold text-xs"
                            >
                              {t("login_username_label")}
                            </label>
                            <div className="flex items-center">
                              <div id="user-prefix">
                                <span className="px-2 py-1 rounded-l-lg font-bold text-gray-700 select-none">
                                  {prefix}
                                </span>
                              </div>
                              <div id="acctIdSuffix1">
                                <select
                                  id="acctIdSuffix1"
                                  value={suffix1}
                                  onChange={(e) => setSuffix1(e.target.value)}
                                  className="w-auto text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-none focus:outline-none focus:border-blue-500"
                                >
                                  {[
                                    ...Array.from({ length: 10 }, (_, i) =>
                                      String(i),
                                    ),
                                    ...Array.from({ length: 26 }, (_, i) =>
                                      String.fromCharCode(65 + i),
                                    ),
                                  ].map((c) => (
                                    <option key={c} value={c}>
                                      {c}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div id="acctIdSuffix2">
                                <select
                                  id="acctIdSuffix2"
                                  value={suffix2}
                                  onChange={(e) => setSuffix2(e.target.value)}
                                  className="w-auto text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-none focus:outline-none focus:border-blue-500"
                                >
                                  {[
                                    ...Array.from({ length: 10 }, (_, i) =>
                                      String(i),
                                    ),
                                    ...Array.from({ length: 26 }, (_, i) =>
                                      String.fromCharCode(65 + i),
                                    ),
                                  ].map((c) => (
                                    <option key={c} value={c}>
                                      {c}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div id="acctIdSuffix3">
                                <select
                                  id="acctIdSuffix3"
                                  value={suffix3}
                                  onChange={(e) => setSuffix3(e.target.value)}
                                  className="w-auto text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-none focus:outline-none focus:border-blue-500"
                                >
                                  {[
                                    ...Array.from({ length: 10 }, (_, i) =>
                                      String(i),
                                    ),
                                    ...Array.from({ length: 26 }, (_, i) =>
                                      String.fromCharCode(65 + i),
                                    ),
                                  ].map((c) => (
                                    <option key={c} value={c}>
                                      {c}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div>
                            <label
                              htmlFor="password"
                              className="block mb-1 font-bold text-xs"
                            >
                              {t("login_password_label")}
                            </label>
                            <input
                              type="password"
                              id="password"
                              value={password}
                              placeholder="Password"
                              onChange={(e) => setPassword(e.target.value)}
                              className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {vpassword ? (
                              <p className="pl-1 text-red-500">
                                {t("member_field_required")}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            <label
                              htmlFor="fname"
                              className="block mb-0 font-bold text-xs"
                            >
                              {t("member_first_name")}
                            </label>
                            <input
                              type="text"
                              id="fname"
                              value={fname}
                              placeholder="Firstname"
                              onChange={(e) => setFname(e.target.value)}
                              className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {vfname ? (
                              <p className="pl-1 text-red-500">
                                {t("member_field_required")}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            <label
                              htmlFor="lname"
                              className="block mb-0 font-bold text-xs"
                            >
                              {t("member_last_name")}
                            </label>
                            <input
                              type="text"
                              id="lname"
                              value={lname}
                              placeholder="Lastname"
                              onChange={(e) => setLname(e.target.value)}
                              className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {vlname ? (
                              <p className="pl-1 text-red-500">
                                {t("member_field_required")}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            <label
                              htmlFor="mobileNumber"
                              className="block mb-0 font-bold text-xs"
                            >
                              {t("member_mobile_number")}
                            </label>
                            <input
                              type="text"
                              id="mobileNumber"
                              value={mobileNumber}
                              placeholder="Mobile Number"
                              onChange={(e) => setMobileNumber(e.target.value)}
                              className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {vmobileNumber ? (
                              <p className="pl-1 text-red-500">
                                {t("member_field_required")}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            <label
                              htmlFor="bank"
                              className="block mb-0 font-bold text-xs"
                            >
                              {t("member_bank")}
                            </label>
                            <input
                              type="text"
                              id="bank"
                              value={bank}
                              placeholder="Bank"
                              onChange={(e) => setBank(e.target.value)}
                              className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {vbank ? (
                              <p className="pl-1 text-red-500">
                                {t("member_field_required")}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            <label
                              htmlFor="banknumber"
                              className="block mb-0 font-bold text-xs"
                            >
                              {t("member_bank_account_number")}
                            </label>
                            <input
                              type="text"
                              id="banknumber"
                              value={banknumber}
                              placeholder="BankAccoutNumber"
                              onChange={(e) => setBanknumber(e.target.value)}
                              className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {vbanknumber ? (
                              <p className="pl-1 text-red-500">
                                {t("member_field_required")}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          {canPickCurrency && (
                            <div>
                              <label
                                htmlFor="currency"
                                className="block mb-0 font-bold text-xs"
                              >
                                {t("agentadd_currency_label")}
                              </label>
                              <select
                                id="currency"
                                value={currencyId}
                                onChange={(e) =>
                                  setCurrencyId(Number(e.target.value))
                                }
                                className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                              >
                                {currencies
                                  .filter((c) => c.status)
                                  .map((c) => (
                                    <option key={c.id} value={c.id}>
                                      {c.code} - {c.name} ({c.symbol})
                                    </option>
                                  ))}
                              </select>
                            </div>
                          )}
                        </div>
                        <MemberCommissionTables
                          thCommission={thCommission}
                          setThCommission={setThCommission}
                          hanoiCommission={hanoiCommission}
                          setHanoiCommission={setHanoiCommission}
                          laosCommission={laosCommission}
                          setLaosCommission={setLaosCommission}
                          yeekee5Commission={yeekee5Commission}
                          setYeekee5Commission={setYeekee5Commission}
                          yeekee10Commission={yeekee10Commission}
                          setYeekee10Commission={setYeekee10Commission}
                          yeekee15Commission={yeekee15Commission}
                          setYeekee15Commission={setYeekee15Commission}
                          packages={packages}
                          packageIds={packageIds}
                          setPackageIds={setPackageIds}
                          agentUsername={byAgent ?? user}
                        />
                      </DialogContent>
                      <DialogActions>
                        <button
                          type="submit"
                          className="bg-gradient-to-b from-brand-gold-300 via-brand-gold-400 to-brand-gold-600 text-brand-ink-onGold border border-brand-gold-200 shadow-gold hover:brightness-105 font-bold py-2 px-4 mr-1 rounded"
                        >
                          <AddBoxIcon /> {t("member_add_button")}
                        </button>
                        <button
                          onClick={handleClose}
                          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                        >
                          {t("common_cancel")}
                        </button>
                      </DialogActions>
                    </form>
                  </div>
                </Dialog>
              </div>
            )}
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default Member;
